/**
 * ═══════════════════════════════════════════════════════════════════════════
 * HOME MAGAZINE - Animazioni e Interattività
 * Parallax, reveal effects, horizontal scroll
 * ═══════════════════════════════════════════════════════════════════════════
 */

(function() {
  'use strict';

  // Configurazione
  const config = {
    parallaxIntensity: 0.3,
    revealThreshold: 0.15,
    smoothScroll: true,
    horizontalScrollSpeed: 1.5
  };

  // Stato
  let ticking = false;
  let scrollY = 0;
  let windowHeight = window.innerHeight;

  /**
   * Inizializzazione
   */
  function init() {
    initRevealAnimations();
    initParallax();
    initHorizontalScroll();
    initSmoothScroll();
    
    // Aggiorna dimensioni al resize
    window.addEventListener('resize', debounce(() => {
      windowHeight = window.innerHeight;
      updateParallax();
    }, 100));

    // Animazione frame
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /**
   * Scroll handler con requestAnimationFrame
   */
  function onScroll() {
    scrollY = window.scrollY;
    
    if (!ticking) {
      requestAnimationFrame(() => {
        updateAnimations();
        ticking = false;
      });
      ticking = true;
    }
  }

  /**
   * Aggiorna tutte le animazioni
   */
  function updateAnimations() {
    updateRevealAnimations();
    updateParallax();
    updateHorizontalScroll();
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * REVEAL ANIMATIONS
   * Elementi che appaiono quando entrano nel viewport
   * ═════════════════════════════════════════════════════════════════════════
   */
  function initRevealAnimations() {
    const revealElements = document.querySelectorAll('[data-reveal]');
    
    revealElements.forEach((el, index) => {
      // Aggiungi delay personalizzato se specificato
      const delay = el.dataset.delay;
      if (delay) {
        el.style.transitionDelay = `${delay}s`;
      }
      
      // Stagger delay per elementi multipli
      const stagger = el.dataset.stagger;
      if (stagger) {
        el.style.transitionDelay = `${index * 0.1}s`;
      }
    });
  }

  function updateRevealAnimations() {
    const revealElements = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    
    revealElements.forEach(el => {
      const rect = el.getBoundingClientRect();
      const triggerPoint = windowHeight * (1 - config.revealThreshold);
      
      if (rect.top < triggerPoint && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    });
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * PARALLAX EFFECTS
   * Elementi che si muovono a velocità diverse durante lo scroll
   * ═════════════════════════════════════════════════════════════════════════
   */
  let parallaxElements = [];

  function initParallax() {
    parallaxElements = [];
    
    // Parallax data-speed (più preciso)
    document.querySelectorAll('[data-speed]').forEach(el => {
      const speed = parseFloat(el.dataset.speed) || 0.5;
      parallaxElements.push({
        el: el,
        type: 'speed',
        speed: speed
      });
    });

    // Parallax legacy (fast/medium/slow)
    const speedMap = {
      'fast': 0.3,
      'medium': 0.5,
      'slow': 0.7
    };

    document.querySelectorAll('[data-parallax]').forEach(el => {
      const speedKey = el.dataset.parallax;
      const speed = speedMap[speedKey] || 0.5;
      
      parallaxElements.push({
        el: el,
        type: 'legacy',
        speed: speed
      });
    });
  }

  function updateParallax() {
    parallaxElements.forEach(item => {
      const rect = item.el.getBoundingClientRect();
      
      // Calcola solo se visibile
      if (rect.bottom < 0 || rect.top > windowHeight) return;
      
      // Calcola offset basato sulla posizione del viewport
      const viewportCenter = windowHeight / 2;
      const elementCenter = rect.top + rect.height / 2;
      const distanceFromCenter = elementCenter - viewportCenter;
      
      // Applica il movimento parallax
      const offset = distanceFromCenter * (1 - item.speed) * config.parallaxIntensity;
      item.el.style.transform = `translateY(${offset}px)`;
    });
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * COLLEZIONI SWIPEABILI
   * Carosello con drag, frecce e dots
   * ═════════════════════════════════════════════════════════════════════════
   */
  let collectionsTrack = null;
  let collectionsPrev = null;
  let collectionsNext = null;
  let collectionsDots = null;
  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;

  function initHorizontalScroll() {
    collectionsTrack = document.getElementById('collectionsTrack');
    collectionsPrev = document.querySelector('.mag-collections__arrow--prev');
    collectionsNext = document.querySelector('.mag-collections__arrow--next');
    collectionsDots = document.getElementById('collectionsDots');
    
    if (!collectionsTrack) return;
    
    const cards = collectionsTrack.querySelectorAll('.mag-collection-card');
    
    // Frecce
    if (collectionsPrev) {
      collectionsPrev.addEventListener('click', () => {
        collectionsTrack.scrollBy({ left: -400, behavior: 'smooth' });
      });
    }
    
    if (collectionsNext) {
      collectionsNext.addEventListener('click', () => {
        collectionsTrack.scrollBy({ left: 400, behavior: 'smooth' });
      });
    }
    
    // Drag/Mouse events
    collectionsTrack.addEventListener('mousedown', (e) => {
      isDragging = true;
      collectionsTrack.style.cursor = 'grabbing';
      startX = e.pageX - collectionsTrack.offsetLeft;
      scrollLeft = collectionsTrack.scrollLeft;
    });
    
    collectionsTrack.addEventListener('mouseleave', () => {
      isDragging = false;
      collectionsTrack.style.cursor = 'grab';
    });
    
    collectionsTrack.addEventListener('mouseup', () => {
      isDragging = false;
      collectionsTrack.style.cursor = 'grab';
    });
    
    collectionsTrack.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - collectionsTrack.offsetLeft;
      const walk = (x - startX) * 2;
      collectionsTrack.scrollLeft = scrollLeft - walk;
    });
    
    // Touch events
    collectionsTrack.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].pageX - collectionsTrack.offsetLeft;
      scrollLeft = collectionsTrack.scrollLeft;
    }, { passive: true });
    
    collectionsTrack.addEventListener('touchend', () => {
      isDragging = false;
    });
    
    collectionsTrack.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      const x = e.touches[0].pageX - collectionsTrack.offsetLeft;
      const walk = (x - startX) * 2;
      collectionsTrack.scrollLeft = scrollLeft - walk;
    }, { passive: true });
    
    // Update dots on scroll
    collectionsTrack.addEventListener('scroll', debounce(updateDots, 100));
  }
  
  // Funzione goToSlide rimossa - non necessaria senza dots
  
  function updateDots() {
    // Abilita/disabilita frecce
    if (collectionsPrev) {
      collectionsPrev.disabled = collectionsTrack.scrollLeft <= 0;
    }
    if (collectionsNext) {
      collectionsNext.disabled = collectionsTrack.scrollLeft >= collectionsTrack.scrollWidth - collectionsTrack.clientWidth - 10;
    }
  }

  function updateHorizontalScroll() {
    // Non più necessario per il nuovo carosello
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * SMOOTH SCROLL per anchor links
   * ═════════════════════════════════════════════════════════════════════════
   */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;
        
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * UTILITY: Debounce
   * ═════════════════════════════════════════════════════════════════════════
   */
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * MAGNETIC EFFECT (opzionale)
   * Elementi che "attirano" il cursore
   * ═════════════════════════════════════════════════════════════════════════
   */
  function initMagneticEffect() {
    const magneticElements = document.querySelectorAll('.mag-btn-outline, .mag-hero__cta');
    
    magneticElements.forEach(el => {
      el.addEventListener('mousemove', (e) => {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        el.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
      });
      
      el.addEventListener('mouseleave', () => {
        el.style.transform = 'translate(0, 0)';
      });
    });
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * CURSOR CUSTOM (opzionale)
   * Cursore personalizzato per desktop
   * ═════════════════════════════════════════════════════════════════════════
   */
  function initCustomCursor() {
    if (window.matchMedia('(pointer: coarse)').matches) return; // Skip su mobile
    
    const cursor = document.createElement('div');
    cursor.className = 'mag-cursor';
    cursor.innerHTML = '<span>View</span>';
    document.body.appendChild(cursor);
    
    const cursorStyle = document.createElement('style');
    cursorStyle.textContent = `
      .mag-cursor {
        position: fixed;
        width: 80px;
        height: 80px;
        background: rgba(0, 0, 0, 0.9);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        pointer-events: none;
        z-index: 9999;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.5);
        transition: opacity 0.3s, transform 0.3s;
        mix-blend-mode: difference;
      }
      .mag-cursor.active {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
    `;
    document.head.appendChild(cursorStyle);
    
    document.addEventListener('mousemove', (e) => {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    
    // Mostra cursore su card prodotti
    document.querySelectorAll('.mag-product-card, .mag-collection-card').forEach(el => {
      el.addEventListener('mouseenter', () => cursor.classList.add('active'));
      el.addEventListener('mouseleave', () => cursor.classList.remove('active'));
    });
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * TEXT SCRAMBLE EFFECT
   * Effetto "decoder" per testi
   * ═════════════════════════════════════════════════════════════════════════
   */
  class TextScramble {
    constructor(el) {
      this.el = el;
      this.chars = '!<>-_\\/[]{}—=+*^?#________';
      this.update = this.update.bind(this);
    }
    
    setText(newText) {
      const oldText = this.el.innerText;
      const length = Math.max(oldText.length, newText.length);
      const promise = new Promise((resolve) => this.resolve = resolve);
      this.queue = [];
      
      for (let i = 0; i < length; i++) {
        const from = oldText[i] || '';
        const to = newText[i] || '';
        const start = Math.floor(Math.random() * 40);
        const end = start + Math.floor(Math.random() * 40);
        this.queue.push({ from, to, start, end });
      }
      
      cancelAnimationFrame(this.frameRequest);
      this.frame = 0;
      this.update();
      return promise;
    }
    
    update() {
      let output = '';
      let complete = 0;
      
      for (let i = 0, n = this.queue.length; i < n; i++) {
        let { from, to, start, end, char } = this.queue[i];
        
        if (this.frame >= end) {
          complete++;
          output += to;
        } else if (this.frame >= start) {
          if (!char || Math.random() < 0.28) {
            char = this.randomChar();
            this.queue[i].char = char;
          }
          output += `<span class="scramble-char">${char}</span>`;
        } else {
          output += from;
        }
      }
      
      this.el.innerHTML = output;
      
      if (complete === this.queue.length) {
        this.resolve();
      } else {
        this.frameRequest = requestAnimationFrame(this.update);
        this.frame++;
      }
    }
    
    randomChar() {
      return this.chars[Math.floor(Math.random() * this.chars.length)];
    }
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * VIDEO LAZY LOADING
   * Carica video solo quando visibile
   * ═════════════════════════════════════════════════════════════════════════
   */
  function initVideoLazyLoading() {
    const videos = document.querySelectorAll('.mag-hero__video');
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            video.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.1 });
      
      videos.forEach(video => observer.observe(video));
    }
  }

  /**
   * ═════════════════════════════════════════════════════════════════════════
   * PRELOAD IMMAGINI
   * Precarica le immagini visibili subito
   * ═════════════════════════════════════════════════════════════════════════
   */
  function preloadImages() {
    const images = document.querySelectorAll('.mag-hero__image, .mag-editorial img');
    images.forEach(img => {
      if (img.dataset.src) {
        const preloadImg = new Image();
        preloadImg.src = img.dataset.src;
      }
    });
  }

  // ═════════════════════════════════════════════════════════════════════════
  // INIZIALIZZAZIONE
  // ═════════════════════════════════════════════════════════════════════════
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Inizializzazioni opzionali
  document.addEventListener('DOMContentLoaded', () => {
    initVideoLazyLoading();
    preloadImages();
    
    // Abilita queste se vuoi effetti extra:
    // initMagneticEffect();
    // initCustomCursor();
  });

})();
